var map = {
	"./downer.svg": "5ce7",
	"./dropDownButton.svg": "d226",
	"./letters.png": "2c81",
	"./load.svg": "3483",
	"./loadS.svg": "4076",
	"./menuBar.svg": "f980",
	"./new.svg": "e15b",
	"./newS.svg": "c109",
	"./numbers.png": "0678",
	"./overwrite.svg": "cfcb",
	"./overwriteS.svg": "73b6",
	"./save.svg": "8fc9",
	"./saveS.svg": "8552",
	"./switchOff.svg": "49f5",
	"./switchOn.svg": "79f1",
	"./upper.svg": "a09b",
	"./xSlider.svg": "62fa",
	"./ySlider.svg": "9784"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ae83";